import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import loader from '../../../assets/Images/loader.gif';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import micon from "../../../assets/Images/schedule.png"

const BusinessOpportunityProWifi = () => {
  const [opportunityDataAll, setOpportunityDataAll] = useState([]);
  const [opportunityDataOpen, setOpportunityDataOpen] = useState([]);
  const [opportunityDataWon, setOpportunityDataWon] = useState([]);
  const [opportunityDataLost, setOpportunityDataLost] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchInputAll, setSearchInputAll] = useState('');
  const [searchInputOpen, setSearchInputOpen] = useState('');
  const [searchInputWon, setSearchInputWon] = useState('');
  const [searchInputLost, setSearchInputLost] = useState('');
  const [searchFilter, setSearchFilter] = useState([]);
  const [flagAll, setFlagAll] = useState(false);
  const [flagOpen, setFlagOpen] = useState(false);
  const [flagWon, setFlagWon] = useState(false);
  const [flagLost, setFlagLost] = useState(false);






  useEffect(() => {
    const fetchDataForStatus = async (status, setterFunction) => {
      try {
        setLoading(true);
        // const currentDate = new Date();
        // const formattedCurrentDate = currentDate.toISOString().split('T')[0];
        // const toDate = formattedCurrentDate;
        // const fromDate = new Date(currentDate);
        // fromDate.setMonth(currentDate.getMonth() - 2);
        // const formattedFromDate = fromDate.toISOString().split('T')[0];

        const currentDate = new Date();

        // Format the date correctly in YYYY-MM-DD format in local time
        const toDate = currentDate.getFullYear() + '-' +
          String(currentDate.getMonth() + 1).padStart(2, '0') + '-' +
          String(currentDate.getDate()).padStart(2, '0');

        const fromDate = new Date(currentDate);
        fromDate.setMonth(currentDate.getMonth() - 2);
        const formattedFromDate = fromDate.getFullYear() + '-' +
          String(fromDate.getMonth() + 1).padStart(2, '0') + '-' +
          String(fromDate.getDate()).padStart(2, '0');

        // console.log("toDate:", toDate);
        // console.log("fromDate:", formattedFromDate);

        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          "Action": "getAllOpportunity",
          "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          "businessSegment": "Business",
          "fromDate": formattedFromDate,
          "password": sessionStorage.getItem('password'),
          "searchBoxValue": "",
          "status": status,
          "toDate": toDate,
          industrySegment: "PG",
          productSegment: "",
          "userName": sessionStorage.getItem('userName')
        };

        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData),
        });

        if (response.ok) {
          const result = await response.json();
          // console.log('API Response:', result);

          if (result && result.Response && result.Response.Status !== "Failure" && result.Response.Data !== undefined) {
            // console.log('Actual Data:', result.Response.Data);
            setterFunction(result.Response.Data);

          } else {
            const errorMessage = (result && result.Response && result.Response.Message);
            // toast.warning(`${errorMessage}`, {
            //   position: toast.POSITION.BOTTOM_CENTER,
            //   autoClose: 1500
            // });
          }
        } else {
          console.error('Error fetching data:', response.status);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        status == "All" && setLoading(false);
      }
    };

    fetchDataForStatus("All", setOpportunityDataAll);
    fetchDataForStatus("Open", setOpportunityDataOpen);
    fetchDataForStatus("Won", setOpportunityDataWon);
    fetchDataForStatus("Lost", setOpportunityDataLost);
  }, []);


  const handleSearchAll = async () => {
    // console.log("Search button clicked");
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        "Action": "getAllOpportunity",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "businessSegment": "Business",
        "fromDate": "",
        "password": sessionStorage.getItem('password'),
        "searchBoxValue": searchInputAll,
        "status": "All",
        "toDate": "",
        industrySegment: "PG",
        productSegment: "",
        "userName": sessionStorage.getItem('userName')
      };
      // Fetch data from the API
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const result = await response.json();

      if (result && result.Response && result.Response.Data) {
        setSearchFilter(result.Response.Data);
        setFlagAll(true);
      } else {
        // console.error("Error fetching data:", response.status);
        const errorMessage = (result && result.Response && result.Response.Message);
        // toast.warning(`${errorMessage}`, {
        //   position: toast.POSITION.BOTTOM_CENTER,
        //   autoClose: 1500
        // });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchOpen = async () => {
    // console.log("Search button clicked");
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        "Action": "getAllOpportunity",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "businessSegment": "Business",
        "fromDate": "",
        "password": sessionStorage.getItem('password'),
        "searchBoxValue": searchInputOpen,
        "status": "Open",
        "toDate": "",
        industrySegment: "PG",
        productSegment: "",
        "userName": sessionStorage.getItem('userName')
      };
      // Fetch data from the API
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const result = await response.json();
      if (result && result.Response && result.Response.Data) {
        setSearchFilter(result.Response.Data);
        setFlagOpen(true);
      } else {
        // console.error("Error fetching data:", response.status);
        const errorMessage = (result && result.Response && result.Response.Message);
        // toast.warning(`${errorMessage}`, {
        //   position: toast.POSITION.BOTTOM_CENTER,
        //   autoClose: 1500
        // });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchWon = async () => {
    // console.log("Search button clicked");
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        "Action": "getAllOpportunity",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "businessSegment": "Business",
        "fromDate": "",
        "password": sessionStorage.getItem('password'),
        "searchBoxValue": searchInputWon,
        "status": "Won",
        "toDate": "",
        industrySegment: "PG",
        productSegment: "",
        "userName": sessionStorage.getItem('userName')
      };
      // Fetch data from the API
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const result = await response.json();
      if (result && result.Response && result.Response.Data) {
        setSearchFilter(result.Response.Data);
        setFlagWon(true);
      } else {
        // console.error("Error fetching data:", response.status);
        const errorMessage = (result && result.Response && result.Response.Message);
        // toast.warning(`${errorMessage}`, {
        //   position: toast.POSITION.BOTTOM_CENTER,
        //   autoClose: 1500
        // });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchLost = async () => {
    // console.log("Search button clicked");
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        "Action": "getAllOpportunity",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "businessSegment": "Business",
        "fromDate": "",
        "password": sessionStorage.getItem('password'),
        "searchBoxValue": searchInputLost,
        "status": "Lost",
        "toDate": "",
        industrySegment: "PG",
        productSegment: "",
        "userName": sessionStorage.getItem('userName')
      };
      // Fetch data from the API
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const result = await response.json();
      if (result && result.Response && result.Response.Data) {
        setSearchFilter(result.Response.Data);
        setFlagLost(true);
      } else {
        // console.error("Error fetching data:", response.status);
        const errorMessage = (result && result.Response && result.Response.Message);
        // toast.warning(`${errorMessage}`, {
        //   position: toast.POSITION.BOTTOM_CENTER,
        //   autoClose: 1500
        // });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // const manageOppForm=(OppId)=>{
  //   // console.log('Cafid',Cafid);
  //   navigate(`/businessPgOpp?OppId=${OppId}`);
  // }

  const manageOppForm = (OppId) => {

    navigate(`/businessPgOpp?OppId=${OppId}`);
  }

  const handleBellClick = (e, OppId) => {
    e.stopPropagation(); // Prevents the card's onClick event
    // console.log("SM button clicked for Contact ID:", OppId);
    // Add further logic here if needed.
    navigate(`/businessMeetingPg?OppId=${OppId}`);

  };
  const navigate = useNavigate();
  const redirectBusinessPage = () => {
    navigate("/businessCardListPG");
  };
  return (
    <>
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span className="" style={{ cursor: "pointer" }} onClick={redirectBusinessPage}>
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">Business PG Opportunity</span>
        </div>
        {/* Navigation tabs: ALL , OPEN , WON , Lost */}
        <div className=" container-fluid">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <a className="nav-link active" data-bs-toggle="tab" href="#all">All</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-bs-toggle="tab" href="#open">Open</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-bs-toggle="tab" href="#won">Won</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-bs-toggle="tab" href="#lost">Lost</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="tab-content tab-main-content">
        {/* ****************** ALL opportunity TAB ************* */}
        <div className="tab-pane fade show active" id="all">
          <div className="container-fluid mb-3 mt-1 p-2 Searchbar-bg">
            <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
              <span>
                <input type="text" className='search-box p-1 border-0' placeholder="Search" style={{ width: '250px' }} value={searchInputAll}
                  onChange={(e) => setSearchInputAll(e.target.value)} />
                <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
              </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button className='btn-sm border-0 bg-light' onClick={handleSearchAll}>Search</button>
            </div>
          </div>

          {/* ***********All content of ALL opportunity TAB************ */}

          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>
              </div>
            </div>
          ) : (
            !flagAll && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {opportunityDataAll?.map((opportunity, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => manageOppForm(opportunity.OppId)}>
                        <div className="m-2 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="opportunity-card-title">{opportunity.LeadName} ({opportunity.OppId})</p>
                            <p className="opportunity-card-text">Mobile No : {opportunity.Mobile}</p>
                            <p className="opportunity-card-text">Email ID : {opportunity.Email}</p>
                            <p className="opportunity-card-text">Status : {opportunity.Status}</p>
                            <p className="opportunity-card-text">Proposal Counter : {opportunity.ProposalCounter}</p>
                            <p className="opportunity-card-text">Created By: {opportunity.CreatedBy}</p>
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "0",
                              transform: "translateY(-50%)"
                            }}
                          >
                            {/* Icon wrapper with relative positioning so the badge can be placed on top of it */}
                            <div
                              onClick={(e) => handleBellClick(e, opportunity.OppId)}
                              style={{ position: "relative", cursor: "pointer", width: "30px", height: "30px" }}
                            >
                              {/* The Icon */}
                              <img
                                src={micon}
                                alt="Schedule Icon"
                                style={{ width: "30px", height: "30px" }}
                              />

                              {/* Red badge (only shown if there's a MeetingCounter) */}
                              {opportunity.MeetingCounter > 0 && (
                                <span
                                  style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "-5px",
                                    backgroundColor: opportunity.MeetingStatus == "0" ? "red" : "green",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: "20px",
                                    height: "20px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    fontWeight: "bold"
                                  }}
                                >
                                  {opportunity.MeetingCounter}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
          )}

          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>
              </div>
            </div>
          ) : (
            flagAll && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {searchFilter.map((opportunity, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => manageOppForm(opportunity.OppId)}>
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="contact-card-title">{opportunity.LeadName} ({opportunity.OppId})</p>
                            <p className="contact-card-text">Mobile No : {opportunity.Mobile}</p>
                            <p className="contact-card-text">Email ID : {opportunity.Email}</p>
                            <p className="contact-card-text">Status : {opportunity.Status}</p>
                            <p className="opportunity-card-text">Proposal Counter : {opportunity.ProposalCounter}</p>
                            <p className="opportunity-card-text">Created By: {opportunity.CreatedBy}</p>

                          </div>
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "0",
                              transform: "translateY(-50%)"
                            }}
                          >
                            {/* Icon wrapper with relative positioning so the badge can be placed on top of it */}
                            <div
                              onClick={(e) => handleBellClick(e, opportunity.OppId)}
                              style={{ position: "relative", cursor: "pointer", width: "30px", height: "30px" }}
                            >
                              {/* The Icon */}
                              <img
                                src={micon}
                                alt="Schedule Icon"
                                style={{ width: "30px", height: "30px" }}
                              />

                              {/* Red badge (only shown if there's a MeetingCounter) */}
                              {opportunity.MeetingCounter > 0 && (
                                <span
                                  style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "-5px",
                                    backgroundColor: opportunity.MeetingStatus == "0" ? "red" : "green",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: "20px",
                                    height: "20px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    fontWeight: "bold"
                                  }}
                                >
                                  {opportunity.MeetingCounter}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
          )}
        </div>

        {/* ****************** open opportunity TAB ************* */}
        <div className="tab-pane fade show" id="open">
          <div className="container-fluid mb-3 mt-1 p-2 Searchbar-bg">
            <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
              <span>
                <input type="text" className='search-box p-1 border-0' placeholder="Search" style={{ width: '250px' }} value={searchInputOpen}
                  onChange={(e) => setSearchInputOpen(e.target.value)} />
                <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
              </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button className='btn-sm border-0 bg-light' onClick={handleSearchOpen}>Search</button>
            </div>
          </div>

          {/* ***********All content of open opportunity TAB************ */}

          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>
              </div>
            </div>
          ) : (
            !flagOpen && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {opportunityDataOpen?.map((opportunity, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => manageOppForm(opportunity.OppId)}>
                        <div className="m-2 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="opportunity-card-title">{opportunity.LeadName} ({opportunity.OppId})</p>
                            <p className="opportunity-card-text">Mobile No : {opportunity.Mobile}</p>
                            <p className="opportunity-card-text">Email ID : {opportunity.Email}</p>
                            <p className="opportunity-card-text">Status : {opportunity.Status}</p>
                            <p className="opportunity-card-text">Proposal Counter : {opportunity.ProposalCounter}</p>
                            <p className="opportunity-card-text">Created By: {opportunity.CreatedBy}</p>

                          </div>
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "0",
                              transform: "translateY(-50%)"
                            }}
                          >
                            {/* Icon wrapper with relative positioning so the badge can be placed on top of it */}
                            <div
                              onClick={(e) => handleBellClick(e, opportunity.OppId)}
                              style={{ position: "relative", cursor: "pointer", width: "30px", height: "30px" }}
                            >
                              {/* The Icon */}
                              <img
                                src={micon}
                                alt="Schedule Icon"
                                style={{ width: "30px", height: "30px" }}
                              />

                              {/* Red badge (only shown if there's a MeetingCounter) */}
                              {opportunity.MeetingCounter > 0 && (
                                <span
                                  style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "-5px",
                                    backgroundColor: opportunity.MeetingStatus == "0" ? "red" : "green",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: "20px",
                                    height: "20px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    fontWeight: "bold"
                                  }}
                                >
                                  {opportunity.MeetingCounter}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
          )}

          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>
              </div>
            </div>
          ) : (
            flagOpen && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {searchFilter?.map((opportunity, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => manageOppForm(opportunity.OppId)}>
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="contact-card-title">{opportunity.LeadName} ({opportunity.OppId})</p>
                            <p className="contact-card-text">Mobile No : {opportunity.Mobile}</p>
                            <p className="contact-card-text">Email ID : {opportunity.Email}</p>
                            <p className="contact-card-text">Status : {opportunity.Status}</p>
                            <p className="opportunity-card-text">Proposal Counter : {opportunity.ProposalCounter}</p>
                            <p className="opportunity-card-text">Created By: {opportunity.CreatedBy}</p>
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "0",
                              transform: "translateY(-50%)"
                            }}
                          >
                            {/* Icon wrapper with relative positioning so the badge can be placed on top of it */}
                            <div
                              onClick={(e) => handleBellClick(e, opportunity.OppId)}
                              style={{ position: "relative", cursor: "pointer", width: "30px", height: "30px" }}
                            >
                              {/* The Icon */}
                              <img
                                src={micon}
                                alt="Schedule Icon"
                                style={{ width: "30px", height: "30px" }}
                              />

                              {/* Red badge (only shown if there's a MeetingCounter) */}
                              {opportunity.MeetingCounter > 0 && (
                                <span
                                  style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "-5px",
                                    backgroundColor: opportunity.MeetingStatus == "0" ? "red" : "green",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: "20px",
                                    height: "20px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    fontWeight: "bold"
                                  }}
                                >
                                  {opportunity.MeetingCounter}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
          )}
        </div>

        {/* ****************** won opportunity TAB ************* */}
        <div className="tab-pane fade show" id="won">
          <div className="container-fluid mb-3 mt-1 p-2 Searchbar-bg">
            <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
              <span>
                <input type="text" className='search-box p-1 border-0' placeholder="Search" style={{ width: '250px' }} value={searchInputWon}
                  onChange={(e) => setSearchInputWon(e.target.value)} />
                <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
              </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button className='btn-sm border-0 bg-light' onClick={handleSearchWon}>Search</button>
            </div>
          </div>

          {/* ***********All content of won opportunity TAB************ */}

          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>
              </div>
            </div>
          ) : (
            !flagWon && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {opportunityDataWon?.map((opportunity, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => manageOppForm(opportunity.OppId)}>
                        <div className="m-2 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="opportunity-card-title">{opportunity.LeadName} ({opportunity.OppId})</p>
                            <p className="opportunity-card-text">Mobile No : {opportunity.Mobile}</p>
                            <p className="opportunity-card-text">Email ID : {opportunity.Email}</p>
                            <p className="opportunity-card-text">Status : {opportunity.Status}</p>
                            <p className="opportunity-card-text">Proposal Counter : {opportunity.ProposalCounter}</p>
                            <p className="opportunity-card-text">Created By: {opportunity.CreatedBy}</p>
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "0",
                              transform: "translateY(-50%)"
                            }}
                          >
                            {/* Icon wrapper with relative positioning so the badge can be placed on top of it */}
                            <div
                              onClick={(e) => handleBellClick(e, opportunity.OppId)}
                              style={{ position: "relative", cursor: "pointer", width: "30px", height: "30px" }}
                            >
                              {/* The Icon */}
                              <img
                                src={micon}
                                alt="Schedule Icon"
                                style={{ width: "30px", height: "30px" }}
                              />

                              {/* Red badge (only shown if there's a MeetingCounter) */}
                              {opportunity.MeetingCounter > 0 && (
                                <span
                                  style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "-5px",
                                    backgroundColor: opportunity.MeetingStatus == "0" ? "red" : "green",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: "20px",
                                    height: "20px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    fontWeight: "bold"
                                  }}
                                >
                                  {opportunity.MeetingCounter}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
          )}

          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>
              </div>
            </div>
          ) : (
            flagWon && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {searchFilter?.map((opportunity, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => manageOppForm(opportunity.OppId)}>
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="contact-card-title">{opportunity.LeadName} ({opportunity.OppId})</p>
                            <p className="contact-card-text">Mobile No : {opportunity.Mobile}</p>
                            <p className="contact-card-text">Email ID : {opportunity.Email}</p>
                            <p className="contact-card-text">Status : {opportunity.Status}</p>
                            <p className="opportunity-card-text">Proposal Counter : {opportunity.ProposalCounter}</p>
                            <p className="opportunity-card-text">Created By: {opportunity.CreatedBy}</p>
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "0",
                              transform: "translateY(-50%)"
                            }}
                          >
                            {/* Icon wrapper with relative positioning so the badge can be placed on top of it */}
                            <div
                              onClick={(e) => handleBellClick(e, opportunity.OppId)}
                              style={{ position: "relative", cursor: "pointer", width: "30px", height: "30px" }}
                            >
                              {/* The Icon */}
                              <img
                                src={micon}
                                alt="Schedule Icon"
                                style={{ width: "30px", height: "30px" }}
                              />

                              {/* Red badge (only shown if there's a MeetingCounter) */}
                              {opportunity.MeetingCounter > 0 && (
                                <span
                                  style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "-5px",
                                    backgroundColor: opportunity.MeetingStatus == "0" ? "red" : "green",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: "20px",
                                    height: "20px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    fontWeight: "bold"
                                  }}
                                >
                                  {opportunity.MeetingCounter}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
          )}
        </div>

        {/* ****************** lost opportunity TAB ************* */}
        <div className="tab-pane fade show" id="lost">
          <div className="container-fluid mb-3 mt-1 p-2 Searchbar-bg">
            <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
              <span>
                <input type="text" className='search-box p-1 border-0' placeholder="Search" style={{ width: '250px' }} value={searchInputLost}
                  onChange={(e) => setSearchInputLost(e.target.value)} />
                <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
              </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button className='btn-sm border-0 bg-light' onClick={handleSearchLost}>Search</button>
            </div>
          </div>

          {/* ***********All content of lost opportunity TAB************ */}

          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>
              </div>
            </div>
          ) : (
            !flagLost && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {opportunityDataLost?.map((opportunity, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => manageOppForm(opportunity.OppId)}>
                        <div className="m-2 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="opportunity-card-title">{opportunity.LeadName} ({opportunity.OppId})</p>
                            <p className="opportunity-card-text">Mobile No : {opportunity.Mobile}</p>
                            <p className="opportunity-card-text">Email ID : {opportunity.Email}</p>
                            <p className="opportunity-card-text">Status : {opportunity.Status}</p>
                            <p className="opportunity-card-text">Proposal Counter : {opportunity.ProposalCounter}</p>
                            <p className="opportunity-card-text">Created By: {opportunity.CreatedBy}</p>
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "0",
                              transform: "translateY(-50%)"
                            }}
                          >
                            {/* Icon wrapper with relative positioning so the badge can be placed on top of it */}
                            <div
                              onClick={(e) => handleBellClick(e, opportunity.OppId)}
                              style={{ position: "relative", cursor: "pointer", width: "30px", height: "30px" }}
                            >
                              {/* The Icon */}
                              <img
                                src={micon}
                                alt="Schedule Icon"
                                style={{ width: "30px", height: "30px" }}
                              />

                              {/* Red badge (only shown if there's a MeetingCounter) */}
                              {opportunity.MeetingCounter > 0 && (
                                <span
                                  style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "-5px",
                                    backgroundColor: opportunity.MeetingStatus == "0" ? "red" : "green",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: "20px",
                                    height: "20px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    fontWeight: "bold"
                                  }}
                                >
                                  {opportunity.MeetingCounter}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
          )}

          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>
              </div>
            </div>
          ) : (
            flagLost && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {searchFilter?.map((opportunity, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => manageOppForm(opportunity.OppId)}>
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="contact-card-title">{opportunity.LeadName} ({opportunity.OppId})</p>
                            <p className="contact-card-text">Mobile No : {opportunity.Mobile}</p>
                            <p className="contact-card-text">Email ID : {opportunity.Email}</p>
                            <p className="contact-card-text">Status : {opportunity.Status}</p>
                            <p className="opportunity-card-text">Proposal Counter : {opportunity.ProposalCounter}</p>
                            <p className="opportunity-card-text">Created By: {opportunity.CreatedBy}</p>
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "0",
                              transform: "translateY(-50%)"
                            }}
                          >
                            {/* Icon wrapper with relative positioning so the badge can be placed on top of it */}
                            <div
                              onClick={(e) => handleBellClick(e, opportunity.OppId)}
                              style={{ position: "relative", cursor: "pointer", width: "30px", height: "30px" }}
                            >
                              {/* The Icon */}
                              <img
                                src={micon}
                                alt="Schedule Icon"
                                style={{ width: "30px", height: "30px" }}
                              />

                              {/* Red badge (only shown if there's a MeetingCounter) */}
                              {opportunity.MeetingCounter > 0 && (
                                <span
                                  style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "-5px",
                                    backgroundColor: opportunity.MeetingStatus == "0" ? "red" : "green",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: "20px",
                                    height: "20px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    fontWeight: "bold"
                                  }}
                                >
                                  {opportunity.MeetingCounter}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
          )}

        </div>
      </div>
    </>
  )
}

export default BusinessOpportunityProWifi;
